import { addElementSetting, getElementSettings } from '../helpers/registered-settings';

const defaultSettings = {
  priority: 0,
};

const registerElementSettings = (config) => {
  const { id } = config;
  if (!id) {
    throw new Error(`Element settings config should have an unique id`);
  }

  const currentElementSettings = getElementSettings();

  if (currentElementSettings.some((setting) => setting.id === id)) {
    throw new Error(`Element settings with id "${id}" is already registered`);
  }

  addElementSetting({
    ...defaultSettings,
    ...config,
  });
};

export default registerElementSettings;
